import React, { useContext, useCallback, useMemo } from 'react';
import { NavigationSlice as NavigationSliceProps } from '../../../../types';
import RouteContext from '../../../../routes/context';
import { NavigationSliceView } from './navigation-component';
import { FacetLink } from './types';
import { useTrackFilterEvent } from '../../filter-tracking';

const NavigationSlice = (props: NavigationSliceProps) => {
  const { links, property } = props;
  const { dispatch, getState } = useContext(RouteContext);
  const { trackFilterEvent } = useTrackFilterEvent({
    property: property || '',
    type: 'facet-navigation',
    title: property || '',
  });
  const filter = (getState().filters || []).find(
    (f: { property: String }) => f.property === property
  );
  const onClick = useCallback(
    (link: FacetLink) => {
      trackFilterEvent(link.id);
      dispatch({
        type: 'FILTER_LIST_UPDATE',
        property,
        id: link.id,
      });
    },
    [property, dispatch, trackFilterEvent]
  );
  const formattedLinks = useMemo(
    () =>
      links?.map(
        (link): FacetLink => {
          const imageUrl = link.productMedia?.first || link.fallbackImage;
          const selected = filter && filter.id === link.id;
          return { ...link, imageUrl, selected };
        }
      ) ?? [],
    [filter, links]
  );
  return <NavigationSliceView onClick={onClick} links={formattedLinks} />;
};

export default NavigationSlice;
